// extracted by mini-css-extract-plugin
export default {"title":"Template_title__1Sdw5","modified":"Template_modified__tep5I","wrapper":"Template_wrapper__FXqpf","content":"Template_content__xDwjv"};